const config = {
  // Backend config
  s3: {
    REGION: import.meta.env.VITE_REGION,
    BUCKET: import.meta.env.VITE_BUCKET,
  },
  apiGateway: {
    REGION: import.meta.env.VITE_REGION,
    URL: import.meta.env.VITE_API_URL,
  },
  mailersApiGateway: {
    REGION: import.meta.env.VITE_REGION,
    URL: import.meta.env.VITE_MAILERS_API_URL,
  },
  cognito: {
    REGION: import.meta.env.VITE_REGION,
    USER_POOL_ID: import.meta.env.VITE_USER_POOL_ID,
    IDENTITY_POOL_ID: import.meta.env.VITE_IDENTITY_POOL_ID,
    APP_CLIENT_ID: import.meta.env.VITE_USER_POOL_CLIENT_ID,
  },
  web: {
    RETRIEVE_URL: import.meta.env.VITE_RETRIEVE_URL,
    ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
  },
};

export default config;
